import { useEffect, useMemo, useState } from 'react';
import { EmbedParams } from '../types/EmbedParams';

export const useEmbedParams = () => {
  const [rawParams, setRawParams] = useState<EmbedParams>({});
  const [isEmbedded, setIsEmbedded] = useState(false);

  // Parse URL parameters on mount
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const parsedParams: EmbedParams = {};

    // Parse only valid embed parameters
    const validKeys: Array<keyof EmbedParams> = ['embed', 'source', 'userAlias', 'isDarkMode'];
    urlParams.forEach((value, key) => {
      if (validKeys.includes(key as keyof EmbedParams)) {
        parsedParams[key as keyof EmbedParams] = value;
      }
    });

    setRawParams(parsedParams);
    setIsEmbedded(urlParams.get('embed') === 'true');
  }, [window.location.search]);

  // Helper functions to convert string parameters to appropriate types
  const getBooleanParam = (key: keyof EmbedParams): boolean => {
    const value = rawParams[key];
    return value === 'true';
  };

  const getStringParam = (key: keyof EmbedParams): string | undefined => {
    return rawParams[key] as string;
  };

  // Parse all parameters with proper types
  // useMemo to prevent unnecessary recreations
  const parsedParams = useMemo(
    () => ({
      embed: getBooleanParam('embed'),
      source: getStringParam('source'),
      userAlias: getStringParam('userAlias')
    }),
    [rawParams]
  );

  return {
    rawParams,
    parsedParams,
    isEmbedded
  };
};
